



























import { defineComponent, SetupContext } from '@vue/composition-api';
import SearchBar from '@/components/utils/SearchBar.vue';
import FilterBar from '@/components/utils/FilterBar.vue';
import CheckboxBar from '@/components/utils/CheckboxBar.vue';
import { IDropdownFilter, ICheckboxFilter } from '@/models/filters/Filters';

interface Props {
  placeholder: string;
  storePath: string;
  filtersDropdown?: IDropdownFilter[];
  filterCheckbox?: ICheckboxFilter;
  noNewItems: Boolean;
  title?: string;
  addCustomPath?: string;
}

const Component = defineComponent({
  name: 'TableHeader',

  props: {
    placeholder: String,
    storePath: String,
    filtersDropdown: [],
    filterCheckbox: Object,
    noNewItems: Boolean,
    title: String,
    addCustomPath: String,
  },

  components: {
    FilterBar,
    SearchBar,
    CheckboxBar,
  },

  setup(props: Props, { root: { $router } }: SetupContext) {
    function showAddForm() {
      if (props.addCustomPath)
        $router.push($router.currentRoute.path + `/${props.addCustomPath}/new`);
      else $router.push($router.currentRoute.path + '/new');
    }

    return {
      showAddForm,
    };
  },
});

export default Component;
